(function () {
  document.querySelectorAll('[data-lg-strip]').forEach(function (strip) {
    if (!strip) return
    strip.addEventListener(
      'error',
      function (e) {
        const img = e.target
        if (!img || img.tagName !== 'IMG') return
        const slot = img.parentNode
        if (!slot) return
        const mark = document.createElement('span')
        mark.className = 'mono'
        mark.textContent = img.getAttribute('data-letter') || ''
        slot.replaceChild(mark, img)
      },
      true
    )

    // The row scrolls horizontally and a mouse wheel only turns vertically: without this
    // there would be no way to reach the end of the list with a mouse.
    strip.addEventListener(
      'wheel',
      function (e) {
        if (e.deltaY === 0 || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return
        if (strip.scrollWidth <= strip.clientWidth) return
        const before = strip.scrollLeft
        strip.scrollLeft = before + e.deltaY
        if (strip.scrollLeft !== before) e.preventDefault()
      },
      { passive: false }
    )
  })
})()
